import { useCallback, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getChatPath } from "../../utils/nav.js";
import { DialogsList } from "../components/DialogsList.jsx";
import { PickClientModal } from "../components/PickClientModal.jsx";

export function DialogsOnlyPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const pickOpen = useMemo(() => searchParams.get("modal") === "pick", [searchParams]);
  const setPickOpen = useCallback(
    (open) => {
      setSearchParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          if (open) p.set("modal", "pick");
          else p.delete("modal");
          return p;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return (
    <>
      <DialogsList
        onOpenChat={(tgId) => navigate(getChatPath(tgId, "/chat"))}
      />

      <PickClientModal
        open={pickOpen}
        onClose={() => setPickOpen(false)}
        onPick={(tgId) => {
          setPickOpen(false);
          navigate(getChatPath(tgId, "/chat"));
        }}
      />
    </>
  );
}

